module.exports = __webpack_public_path__ + "static/img/banner2.3a08555a.png";